module.exports = __webpack_public_path__ + "static/media/community-recycle-icon.89a6ca30.svg";